import { c as _c } from "react/compiler-runtime";
import { Checkbox } from '@xefi/x-react/form';
import { Tooltip } from '@xefi/x-react/tooltip';
import { mergeTailwindClasses } from '@xefi/x-react/utils';
import { useTranslation } from 'react-i18next';
import { QuestionImage } from '@/components/QuestionImage';
import type { QuestionChoice } from '@/models/question';
type CheckBoxFieldProps = {
  choices: QuestionChoice[];
  onChange: (index: number, check: boolean) => void;
  readOnly?: boolean;
  checkOverflow?: boolean;
  hideTooltip?: boolean;
  limit?: number;
};
export const CheckBoxField = t0 => {
  const $ = _c(30);
  const {
    choices,
    onChange,
    readOnly,
    checkOverflow: t1,
    hideTooltip: t2,
    limit
  } = t0;
  const checkOverflow = t1 === undefined ? true : t1;
  const hideTooltip = t2 === undefined ? false : t2;
  const {
    t
  } = useTranslation();
  let t3;
  if ($[0] !== choices) {
    t3 = choices ?? [];
    $[0] = choices;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t3) {
    t4 = t3.filter(_temp);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const selectedCount = t4.length;
  let t5;
  if ($[4] !== checkOverflow) {
    t5 = choice => !(checkOverflow && !choice.is_limit_overflowed || !checkOverflow);
    $[4] = checkOverflow;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const disabledByOverflow = t5;
  let t6;
  if ($[6] !== limit || $[7] !== selectedCount) {
    t6 = choice_0 => typeof limit === "number" && !choice_0.is_selected && selectedCount >= limit;
    $[6] = limit;
    $[7] = selectedCount;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const disabledByLimit = t6;
  let t7;
  if ($[9] !== disabledByLimit || $[10] !== disabledByOverflow) {
    t7 = choice_1 => disabledByOverflow(choice_1) || disabledByLimit(choice_1);
    $[9] = disabledByLimit;
    $[10] = disabledByOverflow;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const isChoiceDisabled = t7;
  let t8;
  if ($[12] !== choices) {
    t8 = choices.some(_temp2);
    $[12] = choices;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const isMediaInChoices = t8;
  let t9;
  if ($[14] !== choices || $[15] !== isChoiceDisabled || $[16] !== onChange || $[17] !== readOnly) {
    t9 = (index, next) => {
      const choice_2 = choices[index];
      if (!choice_2) {
        return;
      }
      if (readOnly || isChoiceDisabled(choice_2)) {
        return;
      }
      onChange(index, typeof next === "boolean" ? next : !choice_2.is_selected);
    };
    $[14] = choices;
    $[15] = isChoiceDisabled;
    $[16] = onChange;
    $[17] = readOnly;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const toggleAt = t9;
  let t10;
  if ($[19] !== choices || $[20] !== disabledByLimit || $[21] !== disabledByOverflow || $[22] !== hideTooltip || $[23] !== isMediaInChoices || $[24] !== readOnly || $[25] !== t || $[26] !== toggleAt) {
    t10 = choices?.map((choice_3, index_0) => {
      const disabledOverflow = disabledByOverflow(choice_3);
      const disabledLimit = disabledByLimit(choice_3);
      const isDisabled = disabledOverflow || disabledLimit || !!readOnly;
      const tooltipMessage = disabledOverflow ? t("choice.unavailable") : disabledLimit ? t("survey.graded.choicesLimit") : "";
      const trigger = <div key={choice_3.id} className={mergeTailwindClasses("flex size-full items-center gap-4", !readOnly && "cursor-pointer")} onClick={() => toggleAt(index_0)}><Checkbox value={choice_3?.id} isSelected={choice_3.is_selected ?? undefined} readOnly={readOnly} isDisabled={isDisabled} onChange={event => {
          event.stopPropagation();
          const next_0 = typeof event === "boolean" ? event : event?.target?.checked ?? !choice_3.is_selected;
          toggleAt(index_0, next_0);
        }} /><p className={mergeTailwindClasses("w-full overflow-auto text-[14px] wrap-break-word", isDisabled && "opacity-30")}>{choice_3?.label}</p>{isMediaInChoices && <div className="pr-2"><QuestionImage media={choice_3.media?.[0]} /></div>}</div>;
      return isDisabled && !hideTooltip ? <Tooltip key={choice_3.id} content={<p className="text-right">{tooltipMessage}</p>} placement="left" showArrow={true} trigger={trigger} /> : trigger;
    });
    $[19] = choices;
    $[20] = disabledByLimit;
    $[21] = disabledByOverflow;
    $[22] = hideTooltip;
    $[23] = isMediaInChoices;
    $[24] = readOnly;
    $[25] = t;
    $[26] = toggleAt;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10) {
    t11 = <div className="flex flex-col gap-4">{t10}</div>;
    $[28] = t10;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
};
function _temp(c) {
  return !!c.is_selected;
}
function _temp2(t0) {
  const {
    media
  } = t0;
  return (media?.length ?? 0) > 0;
}